const APOLA_CART_EVENT = 'cart:update';

function ensureCartNotice() {
  let notice = document.querySelector('[data-apola-cart-notice]');
  if (notice) return notice;

  notice = document.createElement('aside');
  notice.className = 'apola-cart-notice';
  notice.dataset.apolaCartNotice = '';
  notice.setAttribute('role', 'status');
  notice.setAttribute('aria-live', 'polite');
  notice.setAttribute('aria-atomic', 'true');
  notice.innerHTML = `
    <button class="apola-cart-notice__close" type="button" aria-label="Zamknij">×</button>
    <p class="apola-cart-notice__title">Dodano do koszyka ✓</p>
    <p class="apola-cart-notice__product" data-apola-cart-product></p>
    <div class="apola-cart-notice__actions">
      <a class="button" href="/cart">Przejdź do koszyka</a>
      <a class="button button-secondary" href="/pages/oferta" data-apola-continue>Kontynuuj zakupy</a>
    </div>`;
  document.body.appendChild(notice);
  notice.querySelector('.apola-cart-notice__close')?.addEventListener('click', () => notice.classList.remove('is-visible'));
  return notice;
}

function productContext(event) {
  const productId = event.detail?.data?.productId;
  const component = productId
    ? document.querySelector(`product-form-component[data-product-id="${CSS.escape(String(productId))}"]`)
    : null;
  const quickAdd = component?.closest('quick-add-component');
  const cardActions = component?.closest('.apola-card-actions');
  return {
    title: quickAdd?.dataset.productTitle || cardActions?.dataset.productTitle || '',
    continueUrl: component?.dataset.continueUrl || quickAdd?.dataset.continueUrl || '/pages/oferta',
  };
}

document.addEventListener(APOLA_CART_EVENT, (event) => {
  if (event.detail?.data?.source !== 'product-form-component' || event.detail?.data?.didError) return;
  const notice = ensureCartNotice();
  const context = productContext(event);
  const product = notice.querySelector('[data-apola-cart-product]');
  const continueLink = notice.querySelector('[data-apola-continue]');
  if (product) product.textContent = context.title;
  if (continueLink) continueLink.href = context.continueUrl;
  notice.classList.add('is-visible');
  window.clearTimeout(notice.apolaHideTimeout);
  notice.apolaHideTimeout = window.setTimeout(() => notice.classList.remove('is-visible'), 9000);
});

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-apola-quantity-minus], [data-apola-quantity-plus]');
  if (!button) return;
  const input = button.parentElement?.querySelector('input[name="quantity"]');
  if (!(input instanceof HTMLInputElement)) return;
  const step = Number(input.step) || 1;
  const minimum = Number(input.min) || 1;
  const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
  const direction = button.hasAttribute('data-apola-quantity-plus') ? 1 : -1;
  input.value = String(Math.min(maximum, Math.max(minimum, (Number(input.value) || minimum) + direction * step)));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
